<script lang="ts">
  import { Tag, Button } from '$shared/components';
  import CertificateListType from './CertificateListType.svelte';
import { ButtonStyle } from '$shared/constants/ButtonStyle';
import { TagSize } from '$shared/constants/TagSize';

  interface Props {
    value?: ObjectType<any>[];
    title?: string;
    status?: string;
  }

  let { value = [], title = '', status = '' }: Props = $props();
</script>

<div class="board-cert-list-type-wrapper">
  <div class="board-cert-list-type">
    <div data-cy={`${title}-header`} class="header">
      <div class="title">{title || 'Certificate'}</div>
      {#if status}
        <div class="tag"><Tag name={status} size={TagSize.Small}>{status}</Tag></div>
      {/if}
    </div>
    <div class="content">
      {#if value}
        <CertificateListType {value} />
      {:else}
        <div class="warn">No data found</div>
      {/if}
    </div>
    {#if value['__learnMoreAboutCertDisclaimer']}
      <div class="footer">
        <Button style={ButtonStyle.Link}>{value['__learnMoreAboutCertDisclaimer']}</Button>
      </div>
    {/if}
  </div>
</div>

<style>
  .board-cert-list-type-wrapper {
    width: 100%;
    background-color: #fff;
    padding-bottom: 15px;
  }
  .board-cert-list-type {
    margin-top: 15px;
    width: 100%;
    padding: 16px;
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 2px;
    background-color: #fff;
  }
  .header {
    display: flex;
  }
  .header .title {
    font-weight: 700;
    font-size: 22px;
    line-height: 26px;
    color: var(--black);
    margin-bottom: 24px;
  }
  .header .tag {
    margin-left: 20px;
  }
  .board-cert-list-type-wrapper .footer {
    margin-top: 10px;
  }
</style>
